import Button from '@mui/material/Button';
import Box from '@mui/material/Box';

import React, {useState} from "react";
import axios from "axios";
import {useNavigate, useParams} from "react-router-dom";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import {jwtDecode} from "jwt-decode";
import "core-js/stable/atob";

function ResetPassword() {
  const navigate = useNavigate();
  let { tokenId } = useParams();
  const [passwordError, setPasswordError] = useState(null);

  const handleSubmit = (event) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);
    if ((data.get('password') !== data.get('confirm_password')) || data.get('password').length === 0) {
        setPasswordError(true);
    }
    else {
        const decoded = jwtDecode(tokenId);
        const userInfo = decoded.id;
        const email = userInfo[0];
        axios.post('/api/resetpassword',
            {
                email: email,
                password: data.get('password'),
            }).then(function (response) {
            console.log(response);
            if (response.status === 200) {
                // console.log(response);
                // Flash Success somehow
                navigate('/');
            }
        })
        .catch(function (error) {
            console.log(error);
            if (error.response.status === 401) {
                console.log('request failed');
            }
        });
    }
  }

  return (
      <Box
          sx={{
            marginTop: 8,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}>
          <h2>RCP RGA Portal</h2>
          <Typography component="h1" variant="h5">
            Reset Password
          </Typography>
          <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
              <TextField
              margin="normal"
              required
              fullWidth
              error={passwordError}
              name="password"
              label="Password"
              type="password"
              id="password"
              helperText={passwordError ? "Passwords must not be empty and must match." : ""}
            />
              <TextField
              margin="normal"
              required
              fullWidth
              error={passwordError}
              name="confirm_password"
              label="Confirm Password"
              type="password"
              id="confirm_password"
              helperText={passwordError ? "Passwords must not be empty and must match." : ""}
            />
            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{ mt: 3, mb: 2 }}
            >
              Reset
            </Button>
          </Box>
      </Box>
  );
}

export default ResetPassword;